<template>
  <v-card flat class="ma-0 pa-0">
    <v-parallax class="hero-image" :height="$vuetify.breakpoint.mobile ? 200 : 400" src="@/assets/images/ifpi-start-hero.jpg">
      <v-card-title class="display-2 mb-1">{{ $t('login.verify-email-title') }}</v-card-title>
    </v-parallax>
    <v-card-title></v-card-title>
    <v-card-text class="body-1"><p v-html="$t('login.verify-email-info')"></p></v-card-text>
    <v-card-text>
      <v-btn @click="login(null)" class="t-login-btn tonal-button">{{ $t('login.btn-text') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: 'Login',

  methods: {
    login(connType) {
      this.$auth.loginWithRedirect(connType)
    },
  }

}
</script>

<style>

</style>